/**
 * The `variant_id` analytics value for a node's history entry (RFC-1577):
 * `${nodeId}:${index}`, the same format `canvas_variant_kept` uses. Undefined
 * when the index is unknown or invalid — never guessed.
 */
export function outputVariantId(nodeId: string, index: number | null | undefined): string | undefined {
  return typeof index === 'number' && Number.isInteger(index) && index >= 0 ? `${nodeId}:${index}` : undefined
}
